import type { ReactNode } from "react";

export function Chip({
  active,
  onClick,
  children,
}: {
  active?: boolean;
  onClick?: () => void;
  children: ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "8px 14px",
        borderRadius: 999,
        border: "1px solid " + (active ? "var(--accent)" : "var(--line)"),
        background: active ? "var(--accent-tint)" : "var(--surface)",
        color: active ? "var(--accent)" : "var(--ink)",
        fontFamily: "var(--ui)",
        fontSize: 13,
        fontWeight: 600,
        cursor: "pointer",
        transition: "all .12s",
      }}
    >
      {children}
    </button>
  );
}
